import { render, staticRenderFns } from "./number-guard-wizard.vue?vue&type=template&id=40476137"
import script from "./number-guard-wizard.vue?vue&type=script&lang=js"
export * from "./number-guard-wizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports